<div class="photo-area">
  <h2 *ngIf="title" class="title">{{ title }}</h2>
  <p *ngIf="subtitle" class="subtitle">{{ subtitle }}</p>
  <p>{{ action }}</p>

  <div class="slots-container">
    <div
      class="slot-wrapper"
      *ngFor="let slot of [0, 1, 2, 3, 4]; let i = index"
    >
      <div class="slot">
        <!-- Slot com imagem -->
        <ng-container *ngIf="previews[i]; else emptySlot">
          <img
            class="img-preview"
            [src]="getSantizeUrl(previews[i].image || previews[i].url)"
            alt="imagem-preview"
          />

          <div class="slot-actions">
            <!-- Botão editar -->
            <button type="button" (click)="editImage(i)">
              <svg
                width="20"
                height="20"
                viewBox="0 0 20 20"
                fill="none"
                xmlns="http://www.w3.org/2000/svg"
              >
                <path
                  d="M11.05 3.00002L4.20829 10.2417C3.94996 10.5167 3.69996 11.0584 3.64996 11.4334L3.34162 14.1333C3.23329 15.1083 3.93329 15.775 4.89996 15.6084L7.58329 15.15C7.95829 15.0834 8.48329 14.8084 8.74162 14.525L15.5833 7.28335C16.7666 6.03335 17.3 4.60835 15.4583 2.86668C13.625 1.14168 12.2333 1.75002 11.05 3.00002Z"
                  stroke="#292F31"
                  stroke-width="1.5"
                  stroke-miterlimit="10"
                  stroke-linecap="round"
                  stroke-linejoin="round"
                />
                <path
                  d="M9.90833 4.20825C10.2667 6.50825 12.1333 8.26659 14.45 8.49992"
                  stroke="#292F31"
                  stroke-width="1.5"
                  stroke-miterlimit="10"
                  stroke-linecap="round"
                  stroke-linejoin="round"
                />
                <path
                  d="M2.5 18.3333H17.5"
                  stroke="#292F31"
                  stroke-width="1.5"
                  stroke-miterlimit="10"
                  stroke-linecap="round"
                  stroke-linejoin="round"
                />
              </svg>
            </button>

            <!-- Botão remover -->
            <button type="button" (click)="removeImage(i)">
              <svg
                width="20"
                height="20"
                viewBox="0 0 20 20"
                fill="none"
                xmlns="http://www.w3.org/2000/svg"
              >
                <path
                  d="M17.5 4.98332C14.725 4.70832 11.9333 4.56665 9.15 4.56665C7.5 4.56665 5.85 4.64998 4.2 4.81665L2.5 4.98332"
                  stroke="#292F31"
                  stroke-width="1.5"
                  stroke-linecap="round"
                  stroke-linejoin="round"
                />
                <path
                  d="M7.08337 4.14175L7.26671 3.05008C7.40004 2.25841 7.50004 1.66675 8.90837 1.66675H11.0917C12.5 1.66675 12.6084 2.29175 12.7334 3.05841L12.9167 4.14175"
                  stroke="#292F31"
                  stroke-width="1.5"
                  stroke-linecap="round"
                  stroke-linejoin="round"
                />
                <path
                  d="M15.7083 7.6167L15.1666 16.0084C15.075 17.3167 15 18.3334 12.675 18.3334H7.32496C4.99996 18.3334 4.92496 17.3167 4.83329 16.0084L4.29163 7.6167"
                  stroke="#292F31"
                  stroke-width="1.5"
                  stroke-linecap="round"
                  stroke-linejoin="round"
                />
                <path
                  d="M8.60828 13.75H11.3833"
                  stroke="#292F31"
                  stroke-width="1.5"
                  stroke-linecap="round"
                  stroke-linejoin="round"
                />
                <path
                  d="M7.91663 10.4167H12.0833"
                  stroke="#292F31"
                  stroke-width="1.5"
                  stroke-linecap="round"
                  stroke-linejoin="round"
                />
              </svg>
            </button>
          </div>
        </ng-container>

        <!-- Slot vazio -->
        <ng-template #emptySlot>
          <div class="empty-slot">
            <div
              class="photo-container"
              (click)="imageToReplace = i; fileInput.nativeElement.click()"
            >
              <div class="photo-content">
                <svg
                  width="31"
                  height="31"
                  viewBox="0 0 31 31"
                  fill="none"
                  xmlns="http://www.w3.org/2000/svg"
                >
                  <path
                    d="M11.6302 12.9167C13.057 12.9167 14.2135 11.7601 14.2135 10.3333C14.2135 8.9066 13.057 7.75 11.6302 7.75C10.2035 7.75 9.04688 8.9066 9.04688 10.3333C9.04688 11.7601 10.2035 12.9167 11.6302 12.9167Z"
                    stroke-width="2"
                    stroke-linecap="round"
                    stroke-linejoin="round"
                  />
                  <path
                    d="M16.7865 2.58203H11.6198C5.16146 2.58203 2.57812 5.16536 2.57812 11.6237V19.3737C2.57812 25.832 5.16146 28.4154 11.6198 28.4154H19.3698C25.8281 28.4154 28.4115 25.832 28.4115 19.3737V12.9154"
                    stroke-width="2"
                    stroke-linecap="round"
                    stroke-linejoin="round"
                  />
                  <path
                    d="M20.3438 6.45703H27.4479"
                    stroke-width="2"
                    stroke-linecap="round"
                  />
                  <path
                    d="M23.8906 10.0104V2.90625"
                    stroke-width="2"
                    stroke-linecap="round"
                  />
                  <path
                    d="M3.45312 24.4764L9.82104 20.201C10.8415 19.5164 12.314 19.5939 13.231 20.3818L13.6572 20.7564C14.6647 21.6218 16.2922 21.6218 17.2997 20.7564L22.6731 16.1452C23.6806 15.2797 25.3081 15.2797 26.3156 16.1452L28.421 17.9535"
                    stroke-width="2"
                    stroke-linecap="round"
                    stroke-linejoin="round"
                  />
                </svg>
                <div>
                  <span>selecionar</span>
                  <span>imagem</span>
                </div>
              </div>
            </div>
          </div>
        </ng-template>
      </div>

      <!-- Radio de capa -->
      <div class="radio capa-radio">
        <section>
          <input
            type="radio"
            [id]="'capa-' + i"
            name="cover"
            [checked]="coverIndex === i"
            (change)="setAsCover(i)"
          />
          <label [for]="'capa-' + i">
            <div></div>
            <p style="margin-bottom: 0px">capa</p>
          </label>
        </section>
      </div>
    </div>
  </div>

  <!-- Input escondido para upload -->
  <input
    #input
    type="file"
    [accept]="extensions"
    (change)="showPreview($event)"
    hidden
  />
</div>
